'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of supplement plan dk illustration
 */ const SupplementPlanDkIllustration = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 107 107",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "53.5",
                cy: "53.5",
                r: "53.5",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "20.5312",
                y: "32.5332",
                width: "65.7905",
                height: "38.3176",
                rx: "3.61486",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.5312 63.9116V67.2368C20.5312 69.2333 22.1497 70.8517 24.1461 70.8517H82.7069C84.7034 70.8517 86.3218 69.2333 86.3218 67.2368V63.9116H20.5312Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3789",
                y: "70.8516",
                width: "20.2432",
                height: "6.21757",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.293",
                y: "76.9238",
                width: "34.2689",
                height: "1.73514",
                rx: "0.867568",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42",
                y: "45.0527",
                width: "35",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30.1719",
                y: "57.2324",
                width: "46.657",
                height: "2.48837",
                rx: "1.24419",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42",
                y: "39.0527",
                width: "35",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42",
                y: "51.0527",
                width: "35",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M37.4325 41.9075V40.7648H37.733C38.0214 40.7648 38.2552 40.531 38.2552 40.2425V39.1238C38.2552 38.8354 38.0214 38.6016 37.733 38.6016H31.2376C30.9492 38.6016 30.7154 38.8354 30.7154 39.1238V40.2425C30.7154 40.531 30.9492 40.7648 31.2376 40.7648H31.5381V41.9244C31.0867 42.0893 30.6974 42.3859 30.4224 42.7743C30.1475 43.1628 30.0001 43.6246 30 44.0978V51.8183C30 52.1067 30.2338 52.3405 30.5222 52.3405H38.4981C38.7865 52.3405 39.0203 52.1067 39.0203 51.8183V44.0988C39.0203 43.6168 38.8674 43.1467 38.5828 42.754C38.2982 42.3612 37.8962 42.0654 37.4325 41.9075Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30.6602",
                y: "38.5996",
                width: "7.57851",
                height: "2.16529",
                rx: "0.359581",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.SupplementPlanDkIllustration = SupplementPlanDkIllustration;
//# sourceMappingURL=SupplementPlanDkIllustration.cjs.map
